module.exports = __webpack_public_path__ + "static/img/05.6f32c57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/editor/05.png
// module id = KOFT
// module chunks = 3